import { useAppDispatch } from "@/shared/lib/redux"
import { 
    openTransferBonusesModal as openTransferBonusesModalAction,
    closeTransferBonusesModal as closeTransferBonusesModalAction
} from '../../model'

export const useTransferBonusesModal = () => {
    const dispatch = useAppDispatch()

    const openTransferBonusesModal = (onTransfer?: () => void) => {
        dispatch(openTransferBonusesModalAction({
            onTransfer
        }))
    }

    const closeTransferBonusesModal = () => {
        dispatch(closeTransferBonusesModalAction())
    }
    
    return {
        openTransferBonusesModal,
        closeTransferBonusesModal
    }
}